"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_ace_1 = require("react-ace");
var notificationHelper_1 = require("../../../../../../../shared/helpers/notificationHelper");
var CardEditorContainer_1 = require("../../../../../../../shared/components/containers/CardEditorContainer");
var CardRowButtonSet_1 = require("../../../../../../../shared/components/editors/CardRowButtonSet");
var LocaleTPLEditWagerCondition = /** @class */ (function (_super) {
    __extends(LocaleTPLEditWagerCondition, _super);
    function LocaleTPLEditWagerCondition(props) {
        var _this = _super.call(this, props) || this;
        _this.tpl_header = "<#assign content = response?eval>";
        _this.tpl_header_n = "<#assign content = response?eval>\n бонус на сумму ${content.INSTANCE.BONUS_BALANCE} с вейджером ${content.CONFIG.BONUS_WAGER_MULTIPLIER}";
        return _this;
    }
    LocaleTPLEditWagerCondition.prototype.componentWillMount = function () {
        this.setState({
            textRaw: this.props.record.wager_condition_tpl,
            is_window_maximized: false
        });
        this.setBreadcumbs(this.props);
    };
    //public componentWillReceiveProps(nextProps: LocaleTPLEditWagerConditionProps) {
    // this.setState({
    //     textRaw: nextProps.record.wager_condition_tpl,
    // });
    //    this.setBreadcumbs(nextProps);
    //}
    LocaleTPLEditWagerCondition.prototype.setBreadcumbs = function (val) {
        val.state.setExtBreadCrumbPath([
            "Локализации шаблона бонуса",
            "\u0420\u0435\u0434\u0430\u043A\u0442\u043E\u0440 \u0448\u0430\u0431\u043B\u043E\u043D\u0430 \u043E\u0442\u044B\u0433\u0440\u044B\u0448\u0430 \u0432\u0435\u0439\u0434\u0436\u0435\u0440\u0430: [" + val.record.bonus_template_title + "]"
        ]);
    };
    LocaleTPLEditWagerCondition.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.DoUpdateWagerConditionTpl({
                key: this.props.record.key,
                template: this.state.textRaw
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Шаблон отыгрыша бонуса успешно изменен!");
            });
        }
    };
    LocaleTPLEditWagerCondition.prototype.isDataValid = function () {
        if (!this.state.textRaw) {
            notificationHelper_1.default.ShowTextTopRightErrorNotify("Контент не может быть пуcтым!");
            return false;
        }
        if (this.state.textRaw.length === 0) {
            notificationHelper_1.default.ShowTextTopRightErrorNotify("Контент не может быть пуcтым!");
            return false;
        }
        if ((!this.state.textRaw.includes(this.tpl_header))) {
            notificationHelper_1.default.ShowTextTopRightErrorNotify("Шаблон отыгрыша некорректен!");
            return false;
        }
        return true;
    };
    LocaleTPLEditWagerCondition.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    LocaleTPLEditWagerCondition.prototype.OnMaxButtonClick = function (isMax) {
        this.setState({ is_window_maximized: isMax });
    };
    LocaleTPLEditWagerCondition.prototype.getFormTitle = function () {
        return "Изменить шаблон отыгрыша вейджера";
    };
    LocaleTPLEditWagerCondition.prototype.onChange = function (newValue) {
        this.setState({ textRaw: newValue });
    };
    LocaleTPLEditWagerCondition.prototype.getEditorHeight = function () {
        if (this.state.is_window_maximized) {
            return "calc( 100vh - 400px )";
        }
        else {
            return "450px";
        }
    };
    LocaleTPLEditWagerCondition.prototype.onFillClick = function () {
        this.setState({ textRaw: this.tpl_header_n });
    };
    LocaleTPLEditWagerCondition.prototype.onPreviewClick = function () {
        var _this = this;
        this.props.data.DoRenderTemplatePreview({
            template: this.state.textRaw,
            data: this.props.record.bonus_template_json_test_data
        }, function (rendered) {
            _this.props.dialogViewText
                .SetTitle("Просмотр")
                .SetText(rendered)
                .SetOnCloseClick(function () { _this.props.dialogViewText.Close(); })
                .Show();
        });
    };
    LocaleTPLEditWagerCondition.prototype.render = function () {
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), onMaxButtonClick: this.OnMaxButtonClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 600, showMaxButton: true, customHeight: 'calc( 100vh - 250px )' },
            React.createElement("div", { style: {
                    minHeight: "500px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-start"
                } },
                React.createElement(react_ace_1.default, { mode: "ftl", theme: "sqlserver", onChange: this.onChange.bind(this), name: "UNIQUE_ID_OF_RECORD_CONTENT_DIV_TPL_WAGERING", editorProps: { $blockScrolling: true }, width: "100%", height: this.getEditorHeight(), fontSize: 14, value: this.state.textRaw, style: { borderStyle: "solid", borderWidth: "1px", borderColor: "#d9d9d9" } }),
                React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: {
                        btnEdit: "Сохранить",
                        btnGoBack: "Вернуться",
                        btnFill: "Заполнить",
                        btnPreview: "Просмотр"
                    }, onGoBackClick: this.OnGoBackClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this), onFillClick: this.onFillClick.bind(this), onPreviewClick: this.onPreviewClick.bind(this) }))));
    };
    return LocaleTPLEditWagerCondition;
}(React.Component));
exports.default = LocaleTPLEditWagerCondition;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_bonus_templates/ui/component/locales/LocaleTPLEditWagerCondition.tsx
// module id = 1910
// module chunks = 0